import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'phx-expansion-panel',
    templateUrl: './expansion-panel.component.html',
    styleUrls: ['./expansion-panel.component.scss'],
    imports: [NgClass, NgbCollapse]
})
export class ExpansionPanelComponent implements AfterViewInit {
    @ViewChild('bodyContent') bodyContent: ElementRef<HTMLElement>;
    isCollapsed = true;
    hasBodyContent = false;

    constructor(private cd: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        this.hasBodyContent = this.bodyContent.nativeElement && this.bodyContent.nativeElement.children.length > 0;
        this.cd.detectChanges();
    }
}
